export default __webpack_public_path__ + "static/media/1.e80b407f.png";